<template>
  <div class="tabs">
    <button
      v-for="(tab, index) in tabs"
      :key="tab"
      :class="{ active: selected === tab }"
      @click="selectTab(tab)"
    >
      {{ tab }}
    </button>
  </div>
</template>

<script setup>
import { shallowRef, ref, watch, defineProps, defineEmits } from 'vue';

const props = defineProps({
  tabs: {
    type: Array,
    required: true,
  },
  modelValue: {
    type: String,
    default: '',
  },
});

const emit = defineEmits(['update:modelValue']);

const selected = shallowRef(props.modelValue || (props.tabs.length ? props.tabs[0] : ''));

watch(() => props.modelValue, (newVal) => {
  selected.value = newVal;
});

function selectTab(tab) {
  selected.value = tab;
  emit('update:modelValue', tab);
}
</script>

<style scoped>
.tabs {
	display: flex;
  padding: 0.3rem;
  background-color: var(--grey-1);
  border-radius: 0.5rem;
  flex-wrap: wrap;
  justify-content: space-between;
}
button {
  background: none;
  border: none;
  padding: 0.375rem 0.75rem;
  cursor: pointer;
  color: var(--color-2);
}
button:hover {
	background-color: #555;
	opacity: 0.5;
  color: white;
}
button.active {
  background-color: #555;
  color: white;
}

@media (max-width: 1100px) {
  .tabs {
    flex-direction: column
  }
  button {
    width: 100%;
  }
}


</style>
